import  { ACTION_TYPES } from '../../config/constants';

export default function login(state = {}, action) {
	switch (action.type) {
		case ACTION_TYPES.LOGIN_SUCCESS:
			return {
				...state,
				token: action.token
			};
		case ACTION_TYPES.LOGOUT_SUCCESS:
			let newState = Object.assign({}, state);
			//TODO: normalize items removing
			delete newState.token;
			return newState;
		default:
			return state;
	}
}